export const mails: TableModule = {
    name: "mails",
    route: "spa.basedata.mails",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "id",
            sortable: true,
            width: "w-[75px]"
        }, {
            name: "recipient",
            sortable: true,
            pageLink: true,
            mobile: true,
        }, {
            name: "mailTemplate",
            sortable: true,
            sortBy: 'customOrderMailTemplate',
            breakpoint: "xl"
        }, {
            name: "process",
            sortable: true,
            sortBy: 'customOrderProcess',
            breakpoint: "lg"
        }, {
            name: "status",
            sortable: true,
            width: "w-[100px]",
        }, {
            name: "updated_at",
            sortable: true,
            breakpoint: "md"
        }
    ],
    filters: [
        {
            name: "mailTemplate",
            column: "mail_templates.id",
            relation: "mailTemplate",
            type: "searchSelect",
            apiRoute: "spa.basedata.mailTemplates.index",
        }
    ],
    quickFilters: [],
    tools: []
}